/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./button.vue?vue&type=template&id=e08fbbf2&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"
import style0 from "./button.vue?vue&type=style&index=0&id=e08fbbf2&prod&lang=scss"
import style1 from "./button.vue?vue&type=style&index=1&id=e08fbbf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08fbbf2",
  null
  
)

export default component.exports